import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-robotica-educativa',
  templateUrl: './robotica-educativa.component.html',
  styleUrls: ['./robotica-educativa.component.scss'],
})
export class RoboticaEducativaComponent implements OnInit {
  modulesText = {
    text: 'L’obiettivo del corso è di insegnare agli alunni a manovrare le parti meccaniche di un robot e a programmarlo dandogli istruzioni via via sempre più complesse. Grazie a questa conoscenza, in futuro potranno utilizzare questa tecnologia per scopi utili per la società.',
  };

  constructor() {}

  ngOnInit(): void {}
}
